import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { Container } from "@material-ui/core";
import { RootState } from "@app/redux/store/root";
import Footer from "@app/components/footer";
import Header from "@app/components/header";
import useStyles from "./styles";
import NoResultFound from "../../pages/errors/noResultFound";

interface PrivateRouteProps extends RouteProps {
    isPublic?: boolean;
    subheader?: React.ElementType;
    hideFooter?: boolean;
}

const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({
    component,
    subheader: SubHeader,
    isPublic = false,
    path,
    hideFooter = false,
    ...rest
}) => {
    const classes = useStyles();
    const { isLoggedIn = false } = useSelector((state: RootState) => state.authDetails);
    const { appDetails } = useSelector((state: RootState) => state);
    const Component = component as React.ElementType;

    const isNoResultPath = (path: string | undefined) =>
        ["/developer/apps/:id", "/oem/apps/:id", "/tester/apps/:id"].includes(path || "");

    const renderNoResultFound = () => <NoResultFound />;

    const renderLoginRedirect = (fromLocation: any) => (
        <Redirect to={{ pathname: "/login", state: { from: fromLocation } }} />
    );

    const renderMainContent = (props: PrivateRouteProps) => (
        <>
            <Header /> {SubHeader && <SubHeader {...props} />}
            <Container maxWidth="md" disableGutters className={classes.root}>
                <Component {...props} />
            </Container>
            {!hideFooter && <Footer />}
        </>
    );

    const getRenderedContent = (props: PrivateRouteProps) => {
        if (isNoResultPath(path) && appDetails?.noResultFound) {
            return renderNoResultFound();
        }
        if (isLoggedIn || isPublic) {
            return renderMainContent(props);
        }
        return renderLoginRedirect(props.location);
    };

    return <Route {...rest} render={(props) => getRenderedContent(props)} />;
};

export default PrivateRoute;
